import { render, staticRenderFns } from "./tabHBL2UICustom.vue?vue&type=template&id=4eb57244&scoped=true&"
import script from "./tabHBL2UICustom.vue?vue&type=script&lang=js&"
export * from "./tabHBL2UICustom.vue?vue&type=script&lang=js&"
import style0 from "./tabHBL2UICustom.vue?vue&type=style&index=0&id=4eb57244&lang=scss&scoped=true&"
import style1 from "./tabHBL2UICustom.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb57244",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eb57244')) {
      api.createRecord('4eb57244', component.options)
    } else {
      api.reload('4eb57244', component.options)
    }
    module.hot.accept("./tabHBL2UICustom.vue?vue&type=template&id=4eb57244&scoped=true&", function () {
      api.rerender('4eb57244', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabHBL2UICustom.vue"
export default component.exports